import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-community-service',
  templateUrl: './community-service.component.html',
  styleUrls: ['./community-service.component.scss']
})
export class CommunityServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
